export namespace UserAreaEditorDialog {

  export enum Mode {
    'ADD' = 'ADD',
    'REMOVE' = 'REMOVE'
  }

  export enum Page {
    SELECTION_TYPE = 'SELECTION_TYPE',
    SELECT_ORGANIZATION = 'SELECT_ORGANIZATION',
    SELECT_LOCATION = 'SELECT_LOCATION',
    SELECT_ORGANIZATION_AND_LOCATION = 'SELECT_ORGANIZATION_AND_LOCATION',
    SELECT_CLASSES = 'SELECT_CLASSES',
    SELECT_OBJECTS = 'SELECT_OBJECTS',
    SELECT_MODULES = 'SELECT_MODULES',
    SELECT_COMBINATIONS = 'SELECT_COMBINATIONS'
  }

  export enum SelectionType {
    ORG_LOCATION = 'ORG_LOCATION',
    CLASS = 'CLASS'
  }
}
